import React, { PropsWithChildren } from 'react';

export function ContentCardName({ children }: PropsWithChildren) {
  return <p className="content-card__name">{children}</p>;
}
